import _toConsumableArray from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.number.constructor.js";
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue";
var _hoisted_1 = {
  class: "coures-item"
};
var _hoisted_2 = ["src"];
var _hoisted_3 = {
  class: "item-info"
};
var _hoisted_4 = {
  key: 1,
  class: "nice"
};
var _hoisted_5 = {
  class: "item-state"
};
var _hoisted_6 = {
  class: "details"
};
import { getEnvName, getHostName } from '@/util/env';
import { ref } from 'vue';
import { MessagePlugin } from 'tdesign-vue-next';
import { escape2Html } from '@/util/util';
import { validateNull } from '@/util/validate';
import useUserStore from '@/stores/modules/user';
import { storeToRefs } from 'pinia';
export default {
  __name: 'CourseItem',
  props: {
    item: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  emits: ['change'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var _storeToRefs = storeToRefs(useUserStore()),
      token = _storeToRefs.token,
      accountInfo = _storeToRefs.accountInfo;
    var props = __props;
    var emit = __emit;
    /**
     * 显示详情
     * @param {Object} item
     */
    var showDetail = function showDetail(item) {
      var id = item.id,
        isOffShelf = item.isOffShelf,
        source = item.source,
        courseVersion = item.courseVersion;
      if (isOffShelf === 1 && source === 2) {
        MessagePlugin.closeAll();
        MessagePlugin.error('学程已下架');
        return;
      }
      // 学程预览
      var url = '';
      var env_name = getEnvName();
      var hostName = getHostName();
      if (Number(courseVersion) === 2) {
        // 新
        url = "//".concat(env_name || 'edu-', "course.").concat(hostName, "/preview?courseId=").concat(id, "&token=").concat(token.value, "&autyType=").concat(courseVersion, "&version=2");
      } else {
        var accountType = accountInfo.value.accountType;
        // 旧
        url = env_name ? "//".concat(env_name, "web.").concat(hostName, "/courseDetail?id=").concat(item.id, "&token=").concat(token.value) : "//web.zhixuehuijiao.cn/courseDetail?id=".concat(item.id, "&token=").concat(token.value, "&source=").concat(source || 2, "&accountType=").concat(accountType);
      }
      window.open(url, '_blank');
    };
    return function (_ctx, _cache) {
      var _component_svg_icon = _resolveComponent("svg-icon");
      var _component_t_tag = _resolveComponent("t-tag");
      var _component_t_button = _resolveComponent("t-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: "item-cover",
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return showDetail(__props.item);
        })
      }, [__props.item.cover ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        src: __props.item.cover,
        width: "100%",
        height: "100%",
        alt: ""
      }, null, 8, _hoisted_2)) : (_openBlock(), _createBlock(_component_svg_icon, {
        key: 1,
        name: "course-cover",
        width: "72px",
        height: "96px"
      }))]), _createElementVNode("div", _hoisted_3, [_createElementVNode("p", {
        class: "title",
        onClick: _cache[1] || (_cache[1] = function ($event) {
          return showDetail(__props.item);
        })
      }, [__props.item.isVipResource && _ctx.accountType === 2 ? (_openBlock(), _createBlock(_component_svg_icon, {
        key: 0,
        name: "vip-icon"
      })) : _createCommentVNode("", true), __props.item.platformIsBoutique ? (_openBlock(), _createElementBlock("i", _hoisted_4, "精")) : _createCommentVNode("", true), _createTextVNode(" " + _toDisplayString(__props.item.title), 1)]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_t_tag, {
        style: {
          "margin-right": "8px",
          "color": "rgb(35 42 53 / 85%)"
        }
      }, {
        default: _withCtx(function () {
          return _toConsumableArray(_cache[3] || (_cache[3] = [_createTextVNode(" 已发布 ", -1)]));
        }),
        _: 1
      }), __props.item.courseVersion === 1 ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createVNode(_component_t_tag, {
        color: "#232A35D8"
      }, {
        default: _withCtx(function () {
          return _toConsumableArray(_cache[4] || (_cache[4] = [_createTextVNode("旧版本", -1)]));
        }),
        _: 1
      }), _createVNode(_component_t_tag, {
        color: "#232A35D8",
        class: "left-8px right-8px"
      }, {
        default: _withCtx(function () {
          return _toConsumableArray(_cache[5] || (_cache[5] = [_createTextVNode("仅查看", -1)]));
        }),
        _: 1
      })], 64)) : _createCommentVNode("", true), __props.item.source === 2 ? (_openBlock(), _createBlock(_component_t_tag, {
        key: 1,
        color: "#232A35D8"
      }, {
        default: _withCtx(function () {
          return _toConsumableArray(_cache[6] || (_cache[6] = [_createTextVNode("平台库", -1)]));
        }),
        _: 1
      })) : _createCommentVNode("", true), __props.item.source === 4 ? (_openBlock(), _createBlock(_component_t_tag, {
        key: 2,
        color: "#232A35D8"
      }, {
        default: _withCtx(function () {
          return _toConsumableArray(_cache[7] || (_cache[7] = [_createTextVNode("校本库", -1)]));
        }),
        _: 1
      })) : _createCommentVNode("", true), __props.item.source === 8 ? (_openBlock(), _createBlock(_component_t_tag, {
        key: 3,
        color: "#232A35D8"
      }, {
        default: _withCtx(function () {
          return _toConsumableArray(_cache[8] || (_cache[8] = [_createTextVNode("集团库", -1)]));
        }),
        _: 1
      })) : _createCommentVNode("", true), __props.item.source === 12 ? (_openBlock(), _createBlock(_component_t_tag, {
        key: 4,
        color: "#232A35D8"
      }, {
        default: _withCtx(function () {
          return _toConsumableArray(_cache[9] || (_cache[9] = [_createTextVNode("校本库,集团库", -1)]));
        }),
        _: 1
      })) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_6, [_createElementVNode("span", null, "编辑时间：  " + _toDisplayString(__props.item.updateTime), 1), _createElementVNode("span", null, "创编人：  " + _toDisplayString(__props.item.creatorName || __props.item.uploaderName), 1), _createElementVNode("span", null, "原创人  " + _toDisplayString(__props.item.originalName || __props.item.originalUserName), 1), _createElementVNode("span", null, "ID: " + _toDisplayString(__props.item.uniqueCode), 1)])]), _createVNode(_component_t_button, {
        theme: "default",
        onClick: _cache[2] || (_cache[2] = function ($event) {
          return emit('change', __props.item);
        })
      }, {
        default: _withCtx(function () {
          return _toConsumableArray(_cache[10] || (_cache[10] = [_createTextVNode("查看详情", -1)]));
        }),
        _: 1
      })]);
    };
  }
};